module.exports = __webpack_public_path__ + "img/purple-2-squiggly-open.4c326956.svg";